var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#FF0024"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.089,142.094c-9.39-9.391-9.391-24.615,0-34.005c9.39-9.391,24.615-9.391,34.005,0l261.817,261.816         c9.391,9.391,9.391,24.615,0,34.006c-9.39,9.391-24.614,9.391-34.005,0L108.089,142.094z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M369.906,108.089c9.391-9.39,24.615-9.391,34.005,0c9.391,9.39,9.391,24.615,0,34.005L142.095,403.911         c-9.391,9.391-24.615,9.391-34.006,0c-9.391-9.39-9.391-24.614,0-34.005L369.906,108.089z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1936e39ea39231fb589509582eacab32.svg";
export { ForwardRef as ReactComponent };